import React from "react";

import imgs from "./imgs";

type Props = {
  name: string;
  alt?: string;
  height?: number;
  className?: string;
};

const IMG = ({ name, alt, height, className }: Props) => {
  const imgSrc: string = imgs[name as keyof typeof imgs];

  return <img loading="lazy" src={imgSrc} alt={alt || name} height={height} className={className} />;
};

export default IMG;
